import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { EventMessage, EventType } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { b2cPolicies } from '@/routes/AuthConfig';

export function useMsalEvents() {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const callbackId = instance.addEventCallback((event: EventMessage) => {
      // Password reset flow detection
      if (event.eventType === EventType.LOGIN_FAILURE && event.error?.message.includes('AADB2C90118')) {
        instance.loginRedirect({ ...b2cPolicies.authorities.resetPassword, scopes: [] });
      }

      // TODO: This is called on every API call, so we need to check if the event is a login event
      if (
        (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload &&
        'account' in event.payload
      ) {
        /**
         * For the purpose of setting an active account for UI update, we want to consider only the auth
         * response resulting from SUSI flow. "tfp" claim in the id token tells us the policy (NOTE: legacy
         * policies may use "acr" instead of "tfp"). To learn more about B2C tokens, visit:
         * https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
         */
        const account = event.payload.account;
        console.debug('MSAL: Login success event', account);
        if (
          event.payload &&
          'idTokenClaims' in event.payload &&
          event.payload.idTokenClaims &&
          'acr' in event.payload.idTokenClaims &&
          event.payload.idTokenClaims.acr === b2cPolicies.names.signIn.toLowerCase()
        ) {
          console.debug('MSAL: Sign-in flow detected');
        }
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance, navigate]);
}
